import { apiClient, apiClientPublic } from "services/api-client"

export const getCompanies = async () => {
    return await apiClient.get(`/company`)
}

export const getCompaniesPaged = async (page, perPage) => {
    return await apiClient.get(`/company/paged?page=${page}&per_page=${perPage}`)
}

export const getCompanyById = async (id) => {
    return await apiClient.get(`/company/${id}`)
}

export const getCompanyBySlug = async (slug) => {
    return await apiClient.get(`/company/by-slug/${slug}`)
}

export const getCompanyShortBySlug = async (slug) => {
    return await apiClientPublic.get(`/company/short-data-by-slug/${slug}`)
}

export const getMapCompanyBySlug = async (slug) => {
    return await apiClient.get(`/company/map-by-slug/${slug}`)
}

export const getCompanyRolesBySlug = async (slug) => {
    return await apiClient.get(`/company/roles-by-slug/${slug}`)
}

export const addCompany = async (data) => {
    return await apiClient.post('/company', data)
}

export const editCompany = async (id, data) => {
    return await apiClient.put(`/company/${id}`, data)
}

/**
 * LAYER 1 OF PROTECTION - Frontend Whitelist
 *
 * Edit company profile with limited fields
 * Only allows: name, corporateName, description, size, income, industry, domains
 * Protected fields like CNPJ, signedPlan, roles, etc. are NOT sent to the backend
 *
 * @param {string} id - Company ID
 * @param {object} data - Company profile data (will be filtered by caller)
 * @returns {Promise} - API response
 */
export const editCompanyProfile = async (id, data) => {
    return await apiClient.put(`/company/${id}/profile`, data)
}

export const deleteCompany = async (id) => {
    return await apiClient.delete(`/company/${id}`)
}

export const getCompaniesByPartner = async (tenantId) => {
    return await apiClient.get(`/company/by-partner/${tenantId}`)
}

export const getCompaniesByPartnerPaged = async (tenantId, page, perPage) => {
    return await apiClient.get(`/company/by-partner/${tenantId}?page=${page}&per-page=${perPage}`)
}

export const createCompany = async (data, idOnboard) => {
    return await apiClientPublic.post(`/company/onboarding/${idOnboard}`, data)
}

export const editCompanyPlan = async (slug, data) => {
    return await apiClientPublic.put(`/company/onboarding/${slug}`, data)
}

export const getPresetPlan = async (slug) => {
    return await apiClientPublic.get(`/company/site/preset-plan/${slug}`,)
}

export const getCountryConfigs = async () => {
    return await apiClientPublic.get('/company/country-config')
}